import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  Subscription,
} from 'src/swagger-gen/web-secured/models';
import { BaseService } from '../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPlanRepo extends BaseService {
  subscriptionUrl = environment.apiUrl + '/subscriptions';
  readonly BADGES_LIMIT = '20';

  constructor(private http: HttpClient, private logger: NGXLogger) {
    super();
  }

  getReportingList(uid: string,
    offset?: number,
    limit?: number,
    params?: any[]): Observable<any> {
    const url = `${this.subscriptionUrl}/${uid}/reports/search`;

    let requestParams: any;
    let requestString = this.pagination(offset, limit, '200');
    let queryParams = '';
    if (params) {
      params.forEach((p: any) => {
        queryParams += '&' + p.key + '=' + p.value;
      });
    }
    requestString += queryParams;
    requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };

    return this.http.post<any>(url, {}, httpOptions).pipe(
      tap((response) => {
        this.logger.log(`Get Reporting List from backend`, response);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }

  createSubscriptionReport(body: any, uid: string): Observable<any> {
    const url = `${this.subscriptionUrl}/${uid}/reports`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post<any>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  updateSubscriptionReport(uid: string, body: any, reportUid: string): Observable<any> {
    const url = `${this.subscriptionUrl}/${uid}/reports/${reportUid}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.put<any>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

deleteSubscriptionReport(uid: string, reportUid: string): Observable<any> {
  const url = `${this.subscriptionUrl}/${uid}/reports/${reportUid}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.delete<any>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  downloadReportNow(uid: string, startDate: string, endDate: string, reportType: any): Observable<any> {

    const url = `${this.subscriptionUrl}/${uid}/reports/${reportType.toLocaleLowerCase()}`;

    let queryParams = '&' + 'startDate' + '=' + startDate;
    queryParams += '&' + 'endDate' + '=' + endDate;

    const offset = 0;
    const limit = 200;

    let requestString = this.pagination(offset , limit, '200');

    requestString += queryParams;
    const requestParams = new HttpParams({ fromString: requestString });

    const httpOptions: any = {
      headers: this.httpHeaders(),
      params: requestParams,
      responseType: 'blob' as 'json',
      observe: 'response',
    };

    return this.http.get<any>(url, httpOptions).pipe(
      tap((response) => {
        this.logger.log(
          `Get configuration table for station from backend`,
          response
        );
      }), // DEBUG
      catchError(this.handleServerError)
    );

  }

  sendDiffusionListReport(subscriptionUid:string, reportUid:string): Observable<any> {

    const url = `${this.subscriptionUrl}/${subscriptionUid}/reports/${reportUid}/diffusion`;

    const httpOptions: any = {
      headers: this.httpHeaders()
    };

    return this.http.post<any>(url, httpOptions).pipe(
      tap((response) => {
        this.logger.log(`Mail report ${reportUid} for subscription ${subscriptionUid}`);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }
  
  getSubscriptionPlan(uid: string): Observable<Subscription> {
    const url = this.subscriptionUrl + `/${uid}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get<Subscription>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  exportUniqueSubscriptionPlanDefinition(uid: string): Observable<any> {
    const url = `${this.subscriptionUrl}/${uid}/export`;

    const httpOptions: any = {
      headers: this.httpHeaders(),
      responseType: 'blob' as 'json',
      observe: 'response',
    };

    return this.http.get<any>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  importUniqueSubscriptionPlanDefinition(uid: string, file: any): Observable<any> {
    const url = `${this.subscriptionUrl}/${uid}/import`;

    const httpOptions: any = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/vnd.ms-excel'
      ),
      observe: 'response'
    };

    return this.http.post<any>(url, file, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }
}
